import api from '@Api/Api'
export type ManualVcStatus = 'draft' | 'pending' | 'approved' | 'rejected'
export type ManualVcQuote = { amount: number; fee: number; total: number }
export type ManualVcRequest = ManualVcQuote & {
	reference: string
	user_id: number
	status: ManualVcStatus
	receiver_number: string
	sending_number: string
	submitted_at: string
	reviewed_at: string
	rejection_note: string
	has_proof: boolean
	invoice_id: number | null
	invoice?: { invoice_ref: string; price: number; tax: number; total_price: number; status: string; created_at: string }
}
export const manualVcBase = '/dashboard/activity/manual-vc-requests'
export const manualVcApi = {
	config: () => api.get('manual-vc/config').then(r => r.data.data),
	quote: (amount: number) => api.get('manual-vc/quote', { params: { amount } }).then(r => r.data.data as ManualVcQuote),
	list: (page: number, perPage = 20) => api.get('manual-vc/requests', { params: { page, perPage } }).then(r => r.data),
	detail: (reference: string) => api.get(`manual-vc/requests/${reference}`).then(r => r.data.data as ManualVcRequest),
	create: (amount: number, key: string) =>
		api.post('manual-vc/drafts', { amount }, { headers: { 'Idempotency-Key': key } }).then(r => r.data.data as ManualVcRequest),
	submit: (reference: string, phone: string, screenshot: File, onProgress?: (percent: number | undefined) => void) => {
		const form = new FormData()
		form.append('sending_number', phone)
		form.append('screenshot', screenshot)
		return api
			.post(`manual-vc/requests/${reference}/submit`, form, {
				onUploadProgress: (event: { loaded: number; total?: number }) =>
					onProgress?.(event.total ? Math.min(100, Math.floor((event.loaded * 100) / event.total)) : undefined),
			})
			.then(r => r.data.data as ManualVcRequest)
	},
	proof: (reference: string) => api.get(`manual-vc/requests/${reference}/proof`, { responseType: 'blob' }).then(r => r.data as Blob),
}
export function manualVcKey() {
	return Array.from(crypto.getRandomValues(new Uint8Array(16)))
		.map(n => n.toString(16).padStart(2, '0'))
		.join('')
}
